export { default as default } from './modal';
